import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from './Icon';
import styles from './PageHeader.module.css';

export interface PageHeaderProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  back?: { to: string; label: string };
}

export function PageHeader({ eyebrow, title, description, actions, back }: PageHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.text}>
        {back ? (
          <Link to={back.to} className={styles.backLink}>
            <Icon name="arrow-left" size={14} />
            {back.label}
          </Link>
        ) : null}
        {eyebrow ? <div className={styles.eyebrow}>{eyebrow}</div> : null}
        <h1 className={styles.title}>{title}</h1>
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
